<div class="relativePageContainer">
  <div class="page-container" style="display: flex">
    <div class="dx-card"
         style="width: 20%; display: flex; flex-direction: column; padding: 20px; height: auto; flex: 1 1">
      <dx-tree-list
        (onRowClick)="onPartitionRowClick($event)"
        [(selectedRowKeys)]="selectedRowPartitions"
        [autoExpandAll]="true"
        [columnAutoWidth]="true"
        [dataSource]="partitions"
        [height]="'100%'"
        [parentIdExpr]="'parentId'"
        [rootValue]="gmService.user.partition.parentId"
        [showBorders]="true"
        [showRowLines]="false"
        [wordWrapEnabled]="true"
        id="partitionTree"
        keyExpr="id"
        parentIdExpr="parentId"
      >

        <dxo-toolbar>
          <dxi-item location="before">
            <p style="font-size: 22px; margin: 0 0 0 10px;">{{ 'MENU_VOICE.REGISTRY.PARTITIONS' | translate }}</p>
          </dxi-item>
          <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
          </dxi-item>
        </dxo-toolbar>

        <dxo-scrolling
          mode="standard">
        </dxo-scrolling>

        <dxo-search-panel [visible]="true" placeholder="{{'PLACEHOLDERS.SEARCH' | translate}}">
        </dxo-search-panel>
        <dxo-selection mode="single"></dxo-selection>
        <dxi-column caption="{{'REGISTRY.USER.PARTITION' | translate}}" cellTemplate="pictureTemplate"
                    dataField="name"></dxi-column>
        <dxi-column
          [width]="100"
          caption="{{'REGISTRY.USER.ACTIVE' | translate}}"
          dataField="active"
          [showEditorAlways]="false"
          [trueText]="translate.instant('COMMON.YES')"
          [falseText]="translate.instant('COMMON.NO')"></dxi-column>

        <div *dxTemplate="let data of 'pictureTemplate'" style="display: flex; align-items: center; gap: 10px;">
          <label style="font-size: 14px">{{ data.data.name }}</label>
        </div>

      </dx-tree-list>
    </div>
    <div
      style="width: 70%; display: flex; flex-direction: column; height: auto; flex: 5 1; gap: 10px; position: relative;">

      <!-- Shared Drawer at Parent Level -->
      <dx-drawer
        (onInitialized)="subscribeToWindowResize()"
        [(opened)]="isDrawerOpen"
        [closeOnOutsideClick]="false"
        [height]="'100%'"
        [openedStateMode]="'overlap'"
        [position]="'right'"
        [revealMode]="'slide'"
        [ngClass]="isDrawerOpen ? '' : 'noShadowOverlay'"
        template="sharedTemplate"
        style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; pointer-events: none;">

        <!-- Shared Drawer Content -->
        <div *dxTemplate="let data of 'sharedTemplate'"
             [style.width.px]="setWidthOfDrawerPx()"
             class="drawerInnerContent"
             style="border-radius: 10px; pointer-events: auto;">

          <div *ngIf="!!selectedUser" [style.width.px]="setWidthOfDrawerPx()" class="drawerContainer">
            <div class="drawerTitleWrapper">
              <h2 class="partitionName" style="min-width: 0; flex: 1;">{{ selectedUser.firstname }} {{ selectedUser.lastname }}</h2>
              <div style="display: flex; flex-direction: row; align-items: center; gap: 10px">
                <dx-drop-down-button (onItemClick)="onUserActionClick($event.itemData.name)" *ngIf="!isEditMode"
                                     [dropDownOptions]="{width: 'auto'}" [type]="'default'" [stylingMode]="'contained'"
                                     id="userActionsButton" icon="overflow"
                                     text="{{'REGISTRY.USER.BUTTONS.ACTIONS' | translate}}">
                  <dxi-item [visible]="!selectedUser.welcomeSent" icon="email" name="sendWelcomeEmail"
                            text="{{'REGISTRY.USER.SEND_WELCOME_EMAIL' | translate}}"></dxi-item>
                  <dxi-item [visible]="!!selectedUser.welcomeSent" icon="key" name="resetPassword"
                            text="{{'REGISTRY.USER.RESET_PASSWORD' | translate}}"></dxi-item>
                  <dxi-item icon="login" name="impersonate"
                            text="{{'REGISTRY.USER.IMPERSONATE' | translate}}"></dxi-item>
                  <dxi-item [disabled]="selectedUser.id === gmService.user.id || authorizationOPEService.isImpersonating()" icon="lock" name="revokeSessions"
                            text="{{'REGISTRY.USER.REVOKE_SESSIONS' | translate}}"></dxi-item>
                  <dxi-item icon="user" name="changePartition"
                            text="{{'REGISTRY.USER.CHANGE_PARTITION' | translate}}"></dxi-item>
                </dx-drop-down-button>
                <dx-button (onClick)="enableEditMode()" *ngIf="!isEditMode" [type]="'default'" icon="edit"
                           id="editUserButton"
                           text="{{'BUTTONS.UPDATE' | translate}}"></dx-button>
                <dx-button (onClick)="deletingUser = true" *ngIf="!isEditMode" icon="trash"
                           text="{{'BUTTONS.DELETE' | translate}}"
                           type="danger"></dx-button>
                <div *ngIf="isEditMode" style="display: flex; flex-direction: row; align-items: center; gap: 10px">
                  <dx-button (onClick)="saveUser()"
                             [disabled]="!isEditFormValid || !userEdited" [stylingMode]="'contained'" [type]="'default'"
                             icon="save"
                             text="{{'BUTTONS.SAVE' | translate}}"></dx-button>
                  <dx-button
                    (onClick)="disableEditMode();" [type]="'normal'" [stylingMode]="'contained'" icon="revert"
                    text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
                </div>
                <dx-button (onClick)="closeDrawer()" *ngIf="!isEditMode" [type]="'default'"
                           [width]="30"
                           icon="close"></dx-button>
              </div>
            </div>

            <div>
              <dx-form #editUserForm
                       (onFieldDataChanged)="checkEditUserValidation()"
                       (onOptionChanged)="checkEditUserValidation()"
                       [formData]="editedUser"
                       [labelLocation]="'left'"
                       [labelMode]="'floating'"
              >
                <div *dxTemplate="let tab of 'titleWithValidation'" class="flexRow">
                  <span>{{ tab.title }}</span>
                  <div *ngIf="!checkTabValidity(tab, editUserForm)" class="invalidBadge">!</div>
                </div>
                <dxi-item itemType="tabbed">
                  <dxo-tab-panel-options [deferRendering]="false"
                                         [elementAttr]="{class: 'tabPanelAbsolute'}"></dxo-tab-panel-options>

                  <dxi-tab [tabTemplate]="'titleWithValidation'"
                           title="{{'REGISTRY.USER.TABS.INFORMATION' | translate}}">
                    <dxi-item [editorOptions]="userEditTextOptions" dataField="email">
                      <dxo-label text="{{'REGISTRY.USER.EMAIL' | translate}}"></dxo-label>
                      <dxi-validation-rule [max]="gmService.STR_DIM_MID"
                                           [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MID)"
                                           type="stringLength"></dxi-validation-rule>
                      <dxi-validation-rule message="{{'REGISTRY.USER.VALIDATION.EMAIL' | translate}}"
                                           type="required"></dxi-validation-rule>
                      <dxi-validation-rule message="{{'REGISTRY.USER.VALIDATION.EMAIL_FORMAT' | translate}}"
                                           [pattern]="appService.EMAIL_PATTERN"
                                           type="pattern"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [editorOptions]="userEditTextOptions" dataField="firstname">
                      <dxo-label text="{{'REGISTRY.USER.FIRSTNAME' | translate}}"></dxo-label>
                      <dxi-validation-rule [max]="gmService.STR_DIM_MIN"
                                           [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MIN)"
                                           type="stringLength"></dxi-validation-rule>
                      <dxi-validation-rule message="{{'REGISTRY.USER.VALIDATION.FIRSTNAME' | translate}}"
                                           type="required"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [editorOptions]="userEditTextOptions" dataField="lastname">
                      <dxo-label text="{{'REGISTRY.USER.LASTNAME' | translate}}"></dxo-label>
                      <dxi-validation-rule [max]="gmService.STR_DIM_MIN"
                                           [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MIN)"
                                           type="stringLength"></dxi-validation-rule>
                      <dxi-validation-rule message="{{'REGISTRY.USER.VALIDATION.LASTNAME' | translate}}"
                                           type="required"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [editorOptions]="userEditTextOptions" dataField="username">
                      <dxo-label text="{{'REGISTRY.USER.USERNAME' | translate}}"></dxo-label>
                      <dxi-validation-rule [max]="gmService.STR_DIM_MID"
                                           [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MID)"
                                           type="stringLength"></dxi-validation-rule>
                      <dxi-validation-rule message="{{'REGISTRY.USER.VALIDATION.USERNAME' | translate}}"
                                           type="required"></dxi-validation-rule>
                    </dxi-item>

                      <dxi-item [editorOptions]="userEditPasswordOptions" dataField="password">
                        <dxo-label text="{{'REGISTRY.USER.PASSWORD' | translate}}"></dxo-label>
                        <dxi-validation-rule [max]="gmService.STR_DIM_MAX"
                                             [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MAX)"
                                             type="stringLength"></dxi-validation-rule>
                      </dxi-item>

                      <dxi-item [editorOptions]="userEditSwitchOptions" cssClass="smallPadding" dataField="enabled"
                                editorType="dxSwitch">
                        <dxo-label [text]="'REGISTRY.USER.ACTIVE' | translate"></dxo-label>
                      </dxi-item>

                      <dxi-item [caption]="'REGISTRY.USER.OTHER_SETTINGS' | translate" itemType="group" cssClass="other-settings-label">
                        <dxi-item [editorOptions]="{ disabled: !isEditMode, text: ('REGISTRY.USER.WELCOME_SENT' | translate) }"
                                  cssClass="smallPadding" dataField="welcomeSent" editorType="dxCheckBox">
                          <dxo-label [visible]="false"></dxo-label>
                        </dxi-item>
                      </dxi-item>

                  </dxi-tab>

                  <dxi-tab [tabTemplate]="'titleWithValidation'" title="{{'REGISTRY.USER.TABS.ROLES' | translate}}">

                    <dxi-item dataField="roles">

                      <div *dxTemplate="let data of 'content'">

                        <dx-list
                          [dataSource]="roles"
                          [selectionMode]="'single'"
                          [(selectedItemKeys)]="this.editedUser!.roles!"
                          [showSelectionControls]="true"
                          [disabled]="!this.isEditMode"
                          (onSelectionChanged)="checkEditUserValidation()"
                          itemTemplate="roleItemTemplate">

                          <div *dxTemplate="let role of 'roleItemTemplate'">
                            {{ 'REGISTRY.USER.ROLES_NAME.' + role | translate }}
                          </div>
                        </dx-list>

                      </div>
                    </dxi-item>
                  </dxi-tab>

                  <dxi-tab [tabTemplate]="'titleWithValidation'"
                           title="{{'REGISTRY.USER.TABS.LINKED_PARTITIONS' | translate}}">
                    <dxi-item style="gap: 10px; display: flex; flex-direction: column;">
                      <div *dxTemplate>
                        <div
                          style="display: flex; position: absolute; flex-direction: column; top: 0; bottom: 0; left: 0; right: 0;gap: 10px;padding: 20px;">
                          <div style="overflow: hidden;flex: 1 1 100%">
                            <dx-tree-list
                              (onSelectionChanged)="updateLinkedPartitions($event); checkEditUserValidation()"
                              [autoExpandAll]="true"
                              [columnAutoWidth]="true"
                              [dataSource]="linkedPartitionsFiltered"
                              [rootValue]="gmService.user.partition.parentId"
                              [selectedRowKeys]="this.editedUser!.linkedPartitions!"
                              [selection]="{ mode: selectionMode }"
                              [showBorders]="true"
                              [showRowLines]="false"
                              [wordWrapEnabled]="true"
                              height="100%"
                              id="selectLinkedPartitionsTree"
                              keyExpr="id"
                              parentIdExpr="parentId">

                              <dxo-toolbar>
                                <dxi-item location="before">
                                  <p
                                    style="font-size: 22px; margin: 0 0 0 10px;">{{ 'MENU_VOICE.REGISTRY.PARTITIONS' | translate }}</p>
                                </dxi-item>
                                <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
                                </dxi-item>
                              </dxo-toolbar>

                              <dxo-scrolling
                                mode="standard">
                              </dxo-scrolling>

                              <dxo-search-panel [visible]="true" placeholder="{{'PLACEHOLDERS.SEARCH' | translate}}">
                              </dxo-search-panel>
                              <dxi-column caption="{{'REGISTRY.USER.PARTITION' | translate}}"
                                          dataField="name"></dxi-column>
                              <dxi-column [width]="'100'"
                                          caption="{{'REGISTRY.USER.LINKED' | translate}}"
                                          cellTemplate="linkedPartitionSelected"></dxi-column>

                              <div *dxTemplate="let data of 'linkedPartitionSelected'"
                                   style="display: flex; justify-content: center;">
                                {{(this.editedUser!.linkedPartitions!.includes(data.data.id)) ? translate.instant('COMMON.YES') : translate.instant('COMMON.NO')}}
                              </div>

                            </dx-tree-list>
                          </div>
                        </div>
                      </div>
                    </dxi-item>
                  </dxi-tab>

                </dxi-item>

              </dx-form>
            </div>

          </div>
          <div *ngIf="!!selectedExternalApplication" [style.width.px]="setWidthOfDrawerPx()" class="drawerContainer">
            <div class="drawerTitleWrapper">
              <h2 class="partitionName" style="min-width: 0; flex: 1;">{{ selectedExternalApplication.id }}</h2>
              <div style="display: flex; flex-direction: row; align-items: center; gap: 10px">
                <dx-button (onClick)="showEditParentPartitionForm()" *ngIf="!isEditMode" [type]="'default'"
                           icon="user" id="editParentPartitionButton"
                           text="{{'REGISTRY.EXTERNAL_APPLICATION.CHANGE_PARTITION' | translate}}"></dx-button>
                <dx-button (onClick)="enableEditMode()" *ngIf="!isEditMode" [type]="'default'" icon="edit"
                           id="editUserButton"
                           text="{{'BUTTONS.UPDATE' | translate}}"></dx-button>
                <dx-button (onClick)="changingSecretKey = true"
                           icon="key"
                           text="{{'REGISTRY.EXTERNAL_APPLICATION.TEXT.CHANGE_SECRET_KEY' | translate}}"
                           type="normal"
                           class="change-secret-key-button"></dx-button>
                <dx-button (onClick)="deletingExternalApplication = true" *ngIf="!isEditMode" icon="trash"
                           text="{{'BUTTONS.DELETE' | translate}}"
                           type="danger"></dx-button>
                <div *ngIf="isEditMode" style="display: flex; flex-direction: row; align-items: center; gap: 10px">
                  <dx-button (onClick)="saveExternalApplication()"
                             [disabled]="!isEditFormValid || !externalApplicationEdited" [stylingMode]="'contained'"
                             [type]="'default'"
                             icon="save"
                             text="{{'BUTTONS.SAVE' | translate}}"></dx-button>
                  <dx-button
                    (onClick)="disableEditMode();" [type]="'normal'" [stylingMode]="'contained'" icon="revert"
                    text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
                </div>
                <dx-button (onClick)="closeDrawer()" *ngIf="!isEditMode" [type]="'default'"
                           [width]="30"
                           icon="close"></dx-button>
              </div>
            </div>

            <div>
              <dx-form #editExternalApplicationForm
                       (onFieldDataChanged)="checkEditExternalApplicationValidation()"
                       (onOptionChanged)="checkEditExternalApplicationValidation()"
                       [formData]="editedExternalApplication"
                       [labelLocation]="'left'"
                       [labelMode]="'floating'"
              >
                <div *dxTemplate="let tab of 'titleWithValidation'" class="flexRow">
                  <span>{{ tab.title }}</span>
                  <div *ngIf="!checkTabValidity(tab, editExternalApplicationForm)" class="invalidBadge">!</div>
                </div>
                <dxi-item itemType="tabbed">
                  <dxo-tab-panel-options [deferRendering]="false"
                                         [elementAttr]="{class: 'tabPanelAbsolute'}"></dxo-tab-panel-options>

                  <dxi-tab [tabTemplate]="'titleWithValidation'"
                           title="{{'REGISTRY.EXTERNAL_APPLICATION.TABS.INFORMATION' | translate}}">
                    <dxi-item [editorOptions]="externalApplicationEditTextOptions" dataField="email">
                      <dxo-label text="{{'REGISTRY.EXTERNAL_APPLICATION.EMAIL' | translate}}"></dxo-label>
                      <dxi-validation-rule [max]="gmService.STR_DIM_MID"
                                           [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MID)"
                                           type="stringLength"></dxi-validation-rule>
                      <dxi-validation-rule message="{{'REGISTRY.EXTERNAL_APPLICATION.VALIDATION.EMAIL' | translate}}"
                                           type="required"></dxi-validation-rule>
                      <dxi-validation-rule
                        message="{{'REGISTRY.EXTERNAL_APPLICATION.VALIDATION.EMAIL_FORMAT' | translate}}"
                        [pattern]="appService.EMAIL_PATTERN"
                        type="pattern"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [editorOptions]="externalApplicationEditTextOptions" dataField="description">
                      <dxo-label text="{{'REGISTRY.EXTERNAL_APPLICATION.DESCRIPTION' | translate}}"></dxo-label>
                      <dxi-validation-rule
                        message="{{'REGISTRY.EXTERNAL_APPLICATION.VALIDATION.DESCRIPTION' | translate}}"
                        type="required"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [editorOptions]="{
                      dataSource: gmService.localeList,
                      valueExpr: 'locale',
                      itemTemplate: 'localeItemTemplate',
                      fieldTemplate: 'localeFieldTemplate'
                    }" dataField="language"
                              editorType="dxSelectBox"
                    >

                      <dxo-label text="{{'REGISTRY.USER.LANGUAGE' | translate}}"></dxo-label>
                      <dxi-validation-rule message="{{'REGISTRY.USER.VALIDATION.LANGUAGE' | translate}}"
                                           type="required"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [editorOptions]="externalApplicationEditSwitchOptions" cssClass="noPadding"
                              dataField="enabled"
                              editorType="dxSwitch">
                      <dxo-label [text]="'REGISTRY.EXTERNAL_APPLICATION.ACTIVE' | translate"></dxo-label>
                    </dxi-item>

                  </dxi-tab>

                  <dxi-tab title="{{'REGISTRY.EXTERNAL_APPLICATION.TABS.API_CONFIG' | translate}}"
                           [tabTemplate]="'titleWithValidation'">
                    <div *dxTemplate style="display: flex;flex-direction: column;gap: 10px;padding: 20px">
                      <div style="overflow: auto; scrollbar-width: none">
                        <ng-container *ngFor="let apiKey of selectedExternalApplicationApiConfigMapKeys">
                          <!-- Enabled Switch -->
                          <div
                            style="border-bottom: 1px solid #e5e8f0;display: flex;flex-direction: column;gap: 10px;padding-bottom: 10px; flex: 1">
                            <!-- API Endpoint Label -->
                            <span>
                            <strong style="font-size: 15px">{{ getApiConfig(apiKey)?.name }}</strong>
                            </span>

                            <dx-form (onFieldDataChanged)="checkEditExternalApplicationValidation()"
                                     (onOptionChanged)="checkEditExternalApplicationValidation()"
                                     [formData]="getApiConfig(apiKey)" *ngIf="getApiConfig(apiKey)" [colCount]="3"
                                     labelLocation="left">
                              <dxi-item style="align-items: center" dataField="enabled" editorType="dxSwitch"
                                        [editorOptions]="externalApplicationEditSwitchOptions" cssClass="noPadding">
                                <dxo-label
                                  text="{{'REGISTRY.EXTERNAL_APPLICATION.API_CONFIG_ENABLED' | translate}}"></dxo-label>
                              </dxi-item> <!-- Max Requests Per Minute -->
                              <dxi-item dataField="maxRequestsPerMinute" editorType="dxNumberBox"
                                        [editorOptions]="requestLimitEditOptions">
                                <dxo-label
                                  text="{{'REGISTRY.EXTERNAL_APPLICATION.MAX_REQUESTS_PER_MINUTE' | translate}}"></dxo-label>
                              </dxi-item> <!-- Max Array Size -->
                              <dxi-item dataField="maxArraySize" editorType="dxNumberBox"
                                        [editorOptions]="arraySizeEditOptions" [disabled]="!getApiConfig(apiKey)?.canDefineMaxArraySize">
                                <dxo-label
                                  text="{{'REGISTRY.EXTERNAL_APPLICATION.MAX_ARRAY_SIZE' | translate}}"></dxo-label>
                              </dxi-item>
                            </dx-form>
                          </div>
                        </ng-container>
                      </div>

                    </div>
                  </dxi-tab>

                  <dxi-tab title="{{'REGISTRY.EXTERNAL_APPLICATION.TABS.API_CALLS_LOG' | translate}}"
                           [tabTemplate]="'titleWithValidation'">
                    <div style="display:flex; flex-direction: column; gap: 20px; height: 100%">
                      <div style="display:flex; flex-direction: column; gap: 10px">
                        <!-- Dates -->
                        <dx-validation-group>
                          <div style="display:flex; flex-direction: column; gap: 10px">
                            <dx-select-box
                              [searchEnabled]=true
                              label="{{ 'REGISTRY.EXTERNAL_APPLICATION.API_CALLS_LOG.SELECT_API' | translate }}"
                              labelMode="floating"
                              [dataSource]="apiConfigOptions || []"
                              displayExpr="name"
                              valueExpr="key"
                              [(value)]="selectedApiKey"
                              (onItemClick)="apiLogsConfigurationsChanged()"
                              style="width: 100%;">
                            </dx-select-box>

                            <div style="display:flex; flex-direction: row; gap: 10px;">
                              <dx-date-box
                                #dateFromBox
                                [(value)]="apiLogsDateFrom"
                                type="datetime"
                                label="{{ 'REGISTRY.EXTERNAL_APPLICATION.API_CALLS_LOG.FROM' | translate }}"
                                labelMode="floating"
                                applyValueMode="instantly"
                                style="flex: 1; height: 30px"
                                (onValueChanged)="apiLogsConfigurationsChanged()">
                                <dx-validator [validationRules]="fromValidationRules"></dx-validator>
                              </dx-date-box>

                              <dx-date-box
                                #dateToBox
                                [(value)]="apiLogsDateTo"
                                type="datetime"
                                label="{{ 'REGISTRY.EXTERNAL_APPLICATION.API_CALLS_LOG.TO' | translate }}"
                                labelMode="floating"
                                applyValueMode="instantly"
                                style="flex: 1; height: 30px"
                                (onValueChanged)="apiLogsConfigurationsChanged()">
                                <dx-validator [validationRules]="toValidationRules"></dx-validator>H
                              </dx-date-box>
                            </div>
                          </div>
                        </dx-validation-group>
                      </div>


                      <div *ngIf="!selectedApiKey"
                           class="select-partition-label-container" style="height: 100%">
                        <label
                          style="font-size: 24px;">{{ 'REGISTRY.EXTERNAL_APPLICATION.API_CALLS_LOG.SELECT_API_TO_SHOW_LOGS' | translate }}</label>
                      </div>
                      <ng-container *ngIf="!!selectedApiKey">
                        <dx-data-grid
                          style="min-height: 350px;"
                          [columnAutoWidth]="true"
                          [height]="'100%'"
                          [showBorders]="true"
                          [dataSource]="selectedExternalApplicationApiCallLogs"
                          [showRowLines]="false">
                          <dxo-pager [showPageSizeSelector]="true" [visible]="true"></dxo-pager>
                          <dxo-toolbar>
                            <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
                            </dxi-item>
                          </dxo-toolbar>
                          <dxo-search-panel
                            [visible]="true"
                            [width]="'100%'">
                          </dxo-search-panel>
                          <dxo-header-filter [visible]="true"></dxo-header-filter>
                          <dxi-column
                            caption="{{ 'REGISTRY.EXTERNAL_APPLICATION.API_CALLS_LOG.DATE' | translate }}"
                            dataField="timestamp" dataType="datetime">
                            <!--                        <dxo-format-->
                            <!--                          [formatter]="parseDateFromObject">-->
                            <!--                        </dxo-format>-->
                          </dxi-column>
                          <dxi-column caption="{{ 'REGISTRY.EXTERNAL_APPLICATION.API_CALLS_LOG.STATUS' | translate }}"
                                      dataField="httpStatus"></dxi-column>
                          <dxi-column [allowHeaderFiltering]="false"
                                      caption="{{ 'REGISTRY.EXTERNAL_APPLICATION.API_CALLS_LOG.RESPONSE_TIME' | translate }}"
                                      dataField="responseTimeMs"></dxi-column>
                        </dx-data-grid>
                      </ng-container>
                    </div>
                  </dxi-tab>

                  <dxi-tab [tabTemplate]="'titleWithValidation'"
                           title="{{'REGISTRY.EXTERNAL_APPLICATION.TABS.LINKED_PARTITIONS' | translate}}">
                    <dxi-item style="gap: 10px; display: flex; flex-direction: column;">
                      <div *dxTemplate>
                        <div
                          style="display: flex; position: absolute; flex-direction: column; top: 0; bottom: 0; left: 0; right: 0;gap: 10px;padding: 20px;">
                          <div style="overflow: hidden;flex: 1 1 100%">
                            <dx-tree-list
                              (onSelectionChanged)="updateLinkedPartitions($event); checkEditExternalApplicationValidation()"
                              [autoExpandAll]="true"
                              [columnAutoWidth]="true"
                              [dataSource]="linkedPartitionsFiltered"
                              [rootValue]="gmService.user.partition.parentId"
                              [selectedRowKeys]="this.editedExternalApplication!.linkedPartitions!"
                              [selection]="{ mode: selectionMode }"
                              [showBorders]="true"
                              [showRowLines]="false"
                              [wordWrapEnabled]="true"
                              height="100%"
                              id="selectLinkedPartitionsTree"
                              keyExpr="id"
                              parentIdExpr="parentId">

                              <dxo-toolbar>
                                <dxi-item location="before">
                                  <p
                                    style="font-size: 22px; margin: 0 0 0 10px;">{{ 'MENU_VOICE.REGISTRY.PARTITIONS' | translate }}</p>
                                </dxi-item>
                                <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
                                </dxi-item>
                              </dxo-toolbar>

                              <dxo-scrolling
                                mode="standard">
                              </dxo-scrolling>

                              <dxo-search-panel [visible]="true" placeholder="{{'PLACEHOLDERS.SEARCH' | translate}}">
                              </dxo-search-panel>
                              <dxi-column caption="{{'REGISTRY.EXTERNAL_APPLICATION.PARTITION' | translate}}"
                                          dataField="name"></dxi-column>
                              <dxi-column [width]="'100'"
                                          caption="{{'REGISTRY.EXTERNAL_APPLICATION.LINKED' | translate}}"
                                          cellTemplate="linkedPartitionSelected"></dxi-column>

                              <div *dxTemplate="let data of 'linkedPartitionSelected'"
                                   style="display: flex; justify-content: center;">
                                {{(this.editedExternalApplication!.linkedPartitions!.includes(data.data.id)) ? translate.instant('COMMON.YES') : translate.instant('COMMON.NO')}}
                              </div>

                            </dx-tree-list>
                          </div>
                        </div>
                      </div>
                    </dxi-item>
                  </dxi-tab>

                </dxi-item>

                <div *dxTemplate="let items of 'localeItemTemplate'" class="custom-item">
                  <span class="fi fi-{{items.countryFlag}}" style="margin-right: 5px"></span>
                  <span class="flagText">{{ printLocaleText(items.locale) }}</span>
                </div>

                <div *dxTemplate="let items of 'localeFieldTemplate'" class="custom-item">
                  <dx-text-box [value]="printLocaleText(items?.locale)">
                  </dx-text-box>
                </div>

              </dx-form>
            </div>

          </div>

        </div>
      </dx-drawer>

      <div class="dx-card" [ngClass]="isDrawerOpen ? '' : 'noShadowOverlay'" style="pointer-events: auto;">
        <div class="drawerOuterContent">
          <div *ngIf="!this.selectedPartition"
               class="select-partition-label-container">
            <label
              style="font-size: 24px;">{{ 'REGISTRY.USER.TEXT.SELECT_PARTITION' | translate }}</label>
          </div>
          <dx-data-grid (onRowClick)="onUserRowClick($event)"
                        *ngIf="!!this.selectedPartition"
                        [(selectedRowKeys)]="selectedRowUser"
                        [columnAutoWidth]="true"
                        [dataSource]="users"
                        [paging]="{enabled: false}"
                        [showBorders]="true"
                        [showRowLines]="false"
                        [wordWrapEnabled]="true"
                        height="100%"
                        id="userTree"
                        keyExpr="id"
          >

            <dxo-toolbar>
              <dxi-item location="before">
                <p style="font-size: 22px; margin: 0 0 0 10px;">{{ 'MENU_VOICE.REGISTRY.USERS' | translate }}</p>
              </dxi-item>
              <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
              </dxi-item>
              <dxi-item location="before">
                <div *dxTemplate="let data of 'content'">
                  <dx-button (onClick)="showNewUserForm()" hint="{{'BUTTONS.HINTS.ADD' | translate}}" icon="add"
                             stylingMode="text">
                    <i class="vr-ic_fluent_add_24_regular"></i>
                  </dx-button>
                </div>
              </dxi-item>
            </dxo-toolbar>

            <dxo-search-panel [visible]="true" placeholder="{{'PLACEHOLDERS.SEARCH' | translate}}">
            </dxo-search-panel>
            <dxo-selection mode="single"></dxo-selection>
            <dxi-column caption="{{'REGISTRY.USER.USERNAME' | translate}}" dataField="username"></dxi-column>
            <dxi-column caption="{{'REGISTRY.USER.FIRST_AND_LAST_NAME' | translate}}" cellTemplate="firstAndLastName"
                        dataField="firstName"></dxi-column>
            <dxi-column caption="{{'REGISTRY.USER.EMAIL' | translate}}" dataField="email"></dxi-column>
            <dxi-column
              [width]="100"
              caption="{{'REGISTRY.USER.ACTIVE' | translate}}"
              dataField="enabled"
              [showEditorAlways]="false"
              [trueText]="translate.instant('COMMON.YES')"
              [falseText]="translate.instant('COMMON.NO')">
            </dxi-column>
            <div *dxTemplate="let data of 'firstAndLastName'" style="display: flex; align-items: center; gap: 10px;">
              <label style="font-size: 14px">{{ data.data.firstname }} {{ data.data.lastname }}</label>
            </div>

            <div *dxTemplate="let data of 'roleTemplate'" style="display: flex; align-items: center; gap: 10px;">
              <label style="font-size: 14px">{{ data.data.firstname }} {{ data.data.lastname }}</label>
            </div>

          </dx-data-grid>
        </div>
      </div>

      <div class="dx-card" [ngClass]="isDrawerOpen ? '' : 'noShadowOverlay'" style="pointer-events: auto;">
        <div class="drawerOuterContent">
          <div *ngIf="!this.selectedPartition"
               class="select-partition-label-container">
            <label
              style="font-size: 24px;">{{ 'REGISTRY.EXTERNAL_APPLICATION.TEXT.SELECT_PARTITION' | translate }}</label>
          </div>
          <dx-data-grid (onRowClick)="onExternalApplicationRowClick($event)"
                        *ngIf="!!this.selectedPartition"
                        [(selectedRowKeys)]="selectedRowExternalApplication"
                        [columnAutoWidth]="true"
                        [dataSource]="externalApplications"
                        [paging]="{enabled: false}"
                        [showBorders]="true"
                        [showRowLines]="false"
                        [wordWrapEnabled]="true"
                        height="100%"
                        id="userTree2"
                        keyExpr="id">

            <dxo-toolbar>
              <dxi-item location="before">
                <p
                  style="font-size: 22px; margin: 0 0 0 10px;">{{ 'MENU_VOICE.REGISTRY.EXTERNAL_APPLICATIONS' | translate }}</p>
              </dxi-item>
              <dxi-item cssClass="flex-search-bar" location="before" name="searchPanel">
              </dxi-item>
              <dxi-item location="before">
                <div *dxTemplate="let data of 'content'">
                  <dx-button (onClick)="showNewExternalApplicationForm()" hint="{{'BUTTONS.HINTS.ADD' | translate}}"
                             icon="add"
                             stylingMode="text">
                    <i class="vr-ic_fluent_add_24_regular"></i>
                  </dx-button>
                </div>
              </dxi-item>
            </dxo-toolbar>

            <dxo-search-panel [visible]="true" placeholder="{{'PLACEHOLDERS.SEARCH' | translate}}">
            </dxo-search-panel>
            <dxo-selection mode="single"></dxo-selection>
            <dxi-column caption="{{'REGISTRY.EXTERNAL_APPLICATION.ID' | translate}}" [alignment]="'left'"
                        dataField="id"></dxi-column>
            <dxi-column caption="{{'REGISTRY.EXTERNAL_APPLICATION.DESCRIPTION' | translate}}"
                        dataField="description"></dxi-column>
            <dxi-column caption="{{'REGISTRY.EXTERNAL_APPLICATION.EMAIL' | translate}}" dataField="email"></dxi-column>
            <dxi-column
              [width]="100"
              caption="{{'REGISTRY.EXTERNAL_APPLICATION.ACTIVE' | translate}}"
              dataField="enabled"
              [showEditorAlways]="false"
              [trueText]="translate.instant('COMMON.YES')"
              [falseText]="translate.instant('COMMON.NO')">
            </dxi-column>

            <!--            <div *dxTemplate="let data of 'firstAndLastName'" style="display: flex; align-items: center; gap: 10px;">-->
            <!--              <label style="font-size: 14px">{{ data.data.firstname }} {{ data.data.lastname }}</label>-->
            <!--            </div>-->

            <!--            <div *dxTemplate="let data of 'roleTemplate'" style="display: flex; align-items: center; gap: 10px;">-->
            <!--              <label style="font-size: 14px">{{ data.data.firstname }} {{ data.data.lastname }}</label>-->
            <!--            </div>-->

          </dx-data-grid>
        </div>
      </div>

    </div>

  </div>

</div>


<dx-popup
  (onHiding)="editUserPartition = false"
  *ngIf="editUserPartition"
  [dragEnabled]="false"
  [fullScreen]="appService.isSmallScreen()"
  [focusStateEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  [showTitle]="true"
  [title]="'REGISTRY.USER.TEXT.CHANGE_PARTITION' | translate"
  [visible]="true"
  [width]="660"
>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="updateUserPartition()" [disabled]="!checkIfUserPartitionChanged()" [height]="40" icon="save"
               text="{{'BUTTONS.SAVE' | translate}}" type="default"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="closeEditUserPartitionForm()" [height]="40" [stylingMode]="'outlined'"
               icon="close" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
  </dxi-toolbar-item>

  <div style="height: 100%; display: flex; flex-direction: column; align-items: flex-start;">
    <dx-tree-list
      (onRowClick)="onSelectEditUserPartitionClick($event)"
      [(selectedRowKeys)]="selectedRowEditUserPartitionForm"
      [autoExpandAll]="true"
      [columnAutoWidth]="true"
      [dataSource]="partitions"
      [rootValue]="gmService.user.partition.parentId"
      [showBorders]="true"
      [showRowLines]="false"
      [wordWrapEnabled]="true"
      height="100%"
      id="selectUserPartitionTree"
      keyExpr="id"
      parentIdExpr="parentId"
    >

      <dxo-toolbar>
        <dxi-item location="before">
          <p style="font-size: 22px; margin: 0 0 0 10px;">{{ 'MENU_VOICE.REGISTRY.PARTITIONS' | translate }}</p>
        </dxi-item>
        <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
        </dxi-item>
      </dxo-toolbar>

      <dxo-scrolling
        mode="standard">
      </dxo-scrolling>
      <dxo-search-panel [visible]="true" placeholder="{{'PLACEHOLDERS.SEARCH' | translate}}">
      </dxo-search-panel>
      <dxo-selection mode="single"></dxo-selection>
      <dxi-column caption="{{'REGISTRY.PARTITION.NAME' | translate}}" dataField="name"></dxi-column>

    </dx-tree-list>
  </div>
</dx-popup>

<dx-popup
  (onHiding)="editExternalApplicationPartition = false"
  *ngIf="editExternalApplicationPartition"
  [dragEnabled]="false"
  [fullScreen]="appService.isSmallScreen()"
  [focusStateEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  [showTitle]="true"
  [title]="'REGISTRY.EXTERNAL_APPLICATION.TEXT.CHANGE_PARTITION' | translate"
  [visible]="true"
  [width]="660"
>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="updateExternalApplicationPartition()"
               [disabled]="!checkIfExternalApplicationPartitionChanged()" [height]="40" icon="save"
               text="{{'BUTTONS.SAVE' | translate}}" type="default"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="closeEditExternalApplicationPartitionForm()" [height]="40" [stylingMode]="'outlined'"
               icon="close" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
  </dxi-toolbar-item>

  <div style="height: 100%; display: flex; flex-direction: column; align-items: flex-start;">
    <dx-tree-list
      (onRowClick)="onSelectEditExternalApplicationPartitionClick($event)"
      [(selectedRowKeys)]="selectedRowEditExternalApplicationPartitionForm"
      [autoExpandAll]="true"
      [columnAutoWidth]="true"
      [dataSource]="partitions"
      [rootValue]="gmService.user.partition.parentId"
      [showBorders]="true"
      [showRowLines]="false"
      [wordWrapEnabled]="true"
      height="100%"
      id="selectExternalApplicationTree"
      keyExpr="id"
      parentIdExpr="parentId"
    >

      <dxo-toolbar>
        <dxi-item location="before">
          <p style="font-size: 22px; margin: 0 0 0 10px;">{{ 'MENU_VOICE.REGISTRY.PARTITIONS' | translate }}</p>
        </dxi-item>
        <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
        </dxi-item>
      </dxo-toolbar>

      <dxo-scrolling
        mode="standard">
      </dxo-scrolling>
      <dxo-search-panel [visible]="true" placeholder="{{'PLACEHOLDERS.SEARCH' | translate}}">
      </dxo-search-panel>
      <dxo-selection mode="single"></dxo-selection>
      <dxi-column caption="{{'REGISTRY.PARTITION.NAME' | translate}}" dataField="name"></dxi-column>
    </dx-tree-list>
  </div>
</dx-popup>

<dx-popup
  (onHiding)="addUser = false"
  (onShown)="repaintNewUserPartitionTree()"
  *ngIf="addUser"
  [dragEnabled]="false"
  [focusStateEnabled]="false"
  [fullScreen]="appService.isSmallScreen()"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  [showTitle]="true"
  [title]="'REGISTRY.USER.TEXT.ADD_USER' | translate"
  [visible]="true"
  [width]="660"
>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="createNewUser()" [height]="40"
               [stylingMode]="'contained'" [type]="'default'" icon="save"
               text="{{'BUTTONS.SAVE' | translate}}"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="addUser = false; selectedRowNewUserForm = undefined;" [height]="40" [stylingMode]="'outlined'"
               icon="close" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
  </dxi-toolbar-item>

  <dx-form #newUserForm
           [formData]="newUser"
           [labelLocation]="'left'"
           [labelMode]="'floating'"
  >
    <div *dxTemplate="let tab of 'titleWithValidation'" class="flexRow">
      <span>{{ tab.title }}</span>
      <div *ngIf="!checkTabValidity(tab, newUserForm)" class="invalidBadge">!</div>
    </div>
    <dxi-item itemType="tabbed">
      <dxo-tab-panel-options [deferRendering]="false"
                             [elementAttr]="{class: 'tabPanelAbsolute'}"></dxo-tab-panel-options>
      <dxi-tab [tabTemplate]="'titleWithValidation'" title="{{'REGISTRY.USER.TABS.INFORMATION' | translate}}">
        <dxi-item [editorOptions]="userNewTextOptions" dataField="email">
          <dxo-label text="{{'REGISTRY.USER.EMAIL' | translate}}"></dxo-label>
          <dxi-validation-rule [max]="gmService.STR_DIM_MID"
                               [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MID)"
                               type="stringLength"></dxi-validation-rule>
          <dxi-validation-rule message="{{'REGISTRY.USER.VALIDATION.EMAIL' | translate}}"
                               type="required"></dxi-validation-rule>
          <dxi-validation-rule message="{{'REGISTRY.USER.VALIDATION.EMAIL_FORMAT' | translate}}"
                               [pattern]="appService.EMAIL_PATTERN"
                               type="pattern"></dxi-validation-rule>
        </dxi-item>

        <dxi-item [editorOptions]="userNewTextOptions" dataField="firstname">
          <dxo-label text="{{'REGISTRY.USER.FIRSTNAME' | translate}}"></dxo-label>
          <dxi-validation-rule [max]="gmService.STR_DIM_MIN"
                               [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MIN)"
                               type="stringLength"></dxi-validation-rule>
          <dxi-validation-rule message="{{'REGISTRY.USER.VALIDATION.FIRSTNAME' | translate}}"
                               type="required"></dxi-validation-rule>
        </dxi-item>

        <dxi-item [editorOptions]="userNewTextOptions" dataField="lastname">
          <dxo-label text="{{'REGISTRY.USER.LASTNAME' | translate}}"></dxo-label>
          <dxi-validation-rule [max]="gmService.STR_DIM_MIN"
                               [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MIN)"
                               type="stringLength"></dxi-validation-rule>
          <dxi-validation-rule message="{{'REGISTRY.USER.VALIDATION.LASTNAME' | translate}}"
                               type="required"></dxi-validation-rule>
        </dxi-item>

        <dxi-item [editorOptions]="userNewTextOptions" dataField="username">
          <dxo-label text="{{'REGISTRY.USER.USERNAME' | translate}}"></dxo-label>
          <dxi-validation-rule [max]="gmService.STR_DIM_MID"
                               [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MID)"
                               type="stringLength"></dxi-validation-rule>
          <dxi-validation-rule message="{{'REGISTRY.USER.VALIDATION.USERNAME' | translate}}"
                               type="required"></dxi-validation-rule>
        </dxi-item>

        <dxi-item [editorOptions]="userPasswordOptions" dataField="password" editorType="dxTextBox">
          <dxo-label text="{{'REGISTRY.USER.PASSWORD' | translate}}"></dxo-label>
          <dxi-validation-rule [max]="gmService.STR_DIM_MIN"
                               [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MIN)"
                               type="stringLength"></dxi-validation-rule>
          <dxi-validation-rule message="{{'REGISTRY.USER.VALIDATION.PASSWORD' | translate}}"
                               type="required"></dxi-validation-rule>
        </dxi-item>

        <dxi-item [editorOptions]="{
                      dataSource: gmService.localeList,
                      valueExpr: 'locale',
                      itemTemplate: 'localeItemTemplate',
                      fieldTemplate: 'localeFieldTemplate'
                    }" dataField="language"
                  editorType="dxSelectBox"
        >

          <dxo-label text="{{'REGISTRY.USER.LANGUAGE' | translate}}"></dxo-label>
          <dxi-validation-rule message="{{'REGISTRY.USER.VALIDATION.LANGUAGE' | translate}}"
                               type="required"></dxi-validation-rule>
        </dxi-item>


        <dxi-item dataField="enabled" editorType="dxSwitch">
          <dxo-label [text]="'REGISTRY.USER.ACTIVE' | translate"></dxo-label>
        </dxi-item>

        <dxi-item [caption]="'REGISTRY.USER.OTHER_SETTINGS' | translate" itemType="group" cssClass="other-settings-label">
          <dxi-item [editorOptions]="{ text: ('REGISTRY.USER.WELCOME_SENT' | translate) }"
                    dataField="welcomeSent" editorType="dxCheckBox">
            <dxo-label [visible]="false"></dxo-label>
          </dxi-item>
        </dxi-item>

      </dxi-tab>

      <dxi-tab [tabTemplate]="'titleWithValidation'" title="{{'REGISTRY.USER.TABS.ROLES' | translate}}">
        <dxi-item dataField="roles">
          <dxo-label text="{{'REGISTRY.USER.ROLES' | translate}}"></dxo-label>
          <div *dxTemplate="let data of 'content'">
            <dx-data-grid
              (onSelectionChanged)="checkNewUserValidation()"
              [(selectedRowKeys)]="this.newUser!.roles!"
              [columns]="[{ dataField: 'this', caption: 'REGISTRY.USER.TABS.ROLES' | translate, cellTemplate: rolesCellTemplate}]"
              [dataSource]="this.roles"
              [hoverStateEnabled]="true"
              [paging]="{ enabled: false }"
              [scrolling]="{ mode: 'virtual' }"
              [selection]="{ mode: 'multiple' }"
              [showRowLines]="false"
            >
            </dx-data-grid>
          </div>
          <dxi-validation-rule message="{{'REGISTRY.USER.VALIDATION.ROLE' | translate}}"
                               type="required"></dxi-validation-rule>
        </dxi-item>
      </dxi-tab>

      <dxi-tab [tabTemplate]="'titleWithValidation'" title="{{'REGISTRY.USER.TABS.LINKED_PARTITIONS' | translate}}">
        <dxi-item style="gap: 10px; display: flex; flex-direction: column;">
          <div *dxTemplate>
            <div
              style="display: flex; position: absolute; flex-direction: column; top: 0; bottom: 50px; left: 0; right: 0;gap: 10px;padding: 20px;">
              <div style="overflow: hidden;flex: 1 1 100%">
                <dx-tree-list
                  #newUserPartitionTree
                  (onSelectionChanged)="onSelectNewUserPartitionClick($event)"
                  [(selectedRowKeys)]="selectedRowPartitionNewUserForm"
                  [autoExpandAll]="true"
                  [columnAutoWidth]="true"
                  [dataSource]="linkedPartitionsFiltered"
                  [rootValue]="gmService.user.partition.parentId"
                  [showBorders]="true"
                  [showRowLines]="false"
                  [wordWrapEnabled]="true"
                  [selection]="{ mode: 'multiple'}"
                  height="100%"
                  id="selectPartitionTree"
                  keyExpr="id"
                  parentIdExpr="parentId"
                >

                  <dxo-toolbar>
                    <dxi-item location="before">
                      <p
                        style="font-size: 22px; margin: 0 0 0 10px;">{{ 'MENU_VOICE.REGISTRY.PARTITIONS' | translate }}</p>
                    </dxi-item>
                    <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
                    </dxi-item>
                  </dxo-toolbar>

                  <dxo-scrolling
                    mode="standard">
                  </dxo-scrolling>

                  <dxo-search-panel [visible]="true" placeholder="{{'PLACEHOLDERS.SEARCH' | translate}}">
                  </dxo-search-panel>
                  <dxo-selection mode="single"></dxo-selection>
                  <dxi-column caption="{{'REGISTRY.USER.PARTITION' | translate}}" dataField="name"></dxi-column>

                </dx-tree-list>
              </div>
            </div>
          </div>
        </dxi-item>
      </dxi-tab>
    </dxi-item>

    <div *dxTemplate="let items of 'localeItemTemplate'" class="custom-item">
      <span class="fi fi-{{items.countryFlag}}" style="margin-right: 5px"></span>
      <span class="flagText">{{ printLocaleText(items.locale) }}</span>
    </div>

    <div *dxTemplate="let items of 'localeFieldTemplate'" class="custom-item">
      <dx-text-box [value]="printLocaleText(items?.locale)">
      </dx-text-box>
    </div>

  </dx-form>

</dx-popup>


<dx-popup
  class="new-external-application-popup"
  (onHiding)="addExternalApplication = false"
  *ngIf="addExternalApplication"
  [dragEnabled]="false"
  [focusStateEnabled]="false"
  [fullScreen]="appService.isSmallScreen()"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"

  [showTitle]="true"
  [title]="'REGISTRY.EXTERNAL_APPLICATION.TEXT.ADD_EXTERNAL_APPLICATION' | translate"
  [visible]="true"
  [width]="780"
>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="createNewExternalApplication()" [height]="40"
               [stylingMode]="'contained'" [type]="'default'" icon="save"
               text="{{'BUTTONS.SAVE' | translate}}"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="addExternalApplication = false; selectedRowNewExternalApplicationForm = undefined;"
               [height]="40" [stylingMode]="'outlined'"
               icon="close" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
  </dxi-toolbar-item>

  <dx-form #newExternalApplicationForm
           [formData]="newExternalApplication"
           [labelLocation]="'top'"
           [labelMode]="'floating'"
           style="height:100%"
  >
    <div *dxTemplate="let tab of 'titleWithValidation'" class="flexRow">
      <span>{{ tab.title }}</span>
      <div *ngIf="!checkTabValidity(tab, newExternalApplicationForm)" class="invalidBadge">!</div>
    </div>
    <dxi-item itemType="tabbed">
      <dxo-tab-panel-options [deferRendering]="false" height="100%"
      ></dxo-tab-panel-options>
      <dxi-tab [tabTemplate]="'titleWithValidation'"
               title="{{'REGISTRY.EXTERNAL_APPLICATION.TABS.INFORMATION' | translate}}">
        <dxi-item [editorOptions]="externalApplicationNewTextOptions" dataField="email">
          <dxo-label text="{{'REGISTRY.EXTERNAL_APPLICATION.EMAIL' | translate}}"></dxo-label>
          <dxi-validation-rule [max]="gmService.STR_DIM_MID"
                               [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MID)"
                               type="stringLength"></dxi-validation-rule>
          <dxi-validation-rule message="{{'REGISTRY.EXTERNAL_APPLICATION.VALIDATION.EMAIL' | translate}}"
                               type="required"></dxi-validation-rule>
          <dxi-validation-rule message="{{'REGISTRY.EXTERNAL_APPLICATION.VALIDATION.EMAIL_FORMAT' | translate}}"
                               [pattern]="appService.EMAIL_PATTERN"
                               type="pattern"></dxi-validation-rule>
        </dxi-item>

        <dxi-item [editorOptions]="externalApplicationNewTextOptions" dataField="description">
          <dxo-label text="{{'REGISTRY.EXTERNAL_APPLICATION.DESCRIPTION' | translate}}"></dxo-label>
          <dxi-validation-rule message="{{'REGISTRY.EXTERNAL_APPLICATION.VALIDATION.DESCRIPTION' | translate}}"
                               type="required"></dxi-validation-rule>
        </dxi-item>

        <dxi-item [editorOptions]="{
                      dataSource: gmService.localeList,
                      valueExpr: 'locale',
                      itemTemplate: 'localeItemTemplate',
                      fieldTemplate: 'localeFieldTemplate'
                    }" dataField="language"
                  editorType="dxSelectBox"
        >

          <dxo-label text="{{'REGISTRY.EXTERNAL_APPLICATION.LANGUAGE' | translate}}"></dxo-label>
          <dxi-validation-rule message="{{'REGISTRY.EXTERNAL_APPLICATION.VALIDATION.LANGUAGE' | translate}}"
                               type="required"></dxi-validation-rule>
        </dxi-item>


        <dxi-item dataField="enabled" editorType="dxSwitch">
          <dxo-label [text]="'REGISTRY.EXTERNAL_APPLICATION.ACTIVE' | translate"></dxo-label>
        </dxi-item>

      </dxi-tab>

      <dxi-tab title="{{ 'REGISTRY.EXTERNAL_APPLICATION.TABS.API_CONFIG' | translate }}"
               [tabTemplate]="'titleWithValidation'">
        <div *dxTemplate>
          <div style="display: flex; flex-direction: column; gap: 10px;">
            <ng-container *ngFor="let apiKey of selectedExternalApplicationApiConfigMapKeys">
              <!-- Enabled Switch -->
              <div
                style="border-bottom: 1px solid #e5e8f0; display: flex; flex-direction: column; gap: 10px; padding-bottom: 10px;">
                <!-- API Endpoint Label -->
                <label style="font-weight: bold; font-size: 15px">{{ getDefaultApiConfig(apiKey)?.name }}</label>

                <dx-form [formData]="getDefaultApiConfig(apiKey)" *ngIf="getDefaultApiConfig(apiKey)" [colCount]="5"
                         labelLocation="left">
                  <dxi-item dataField="enabled" editorType="dxSwitch"
                            [editorOptions]="externalApplicationNewSwitchOptions" cssClass="noPadding" [colSpan]="1">
                    <dxo-label text="{{'REGISTRY.EXTERNAL_APPLICATION.API_CONFIG_ENABLED' | translate}}"></dxo-label>
                  </dxi-item>
                  <dxi-item dataField="maxRequestsPerMinute" editorType="dxNumberBox"
                            [editorOptions]="requestLimitNewOptions"  [colSpan]="2">
                    <dxo-label
                      text="{{'REGISTRY.EXTERNAL_APPLICATION.MAX_REQUESTS_PER_MINUTE' | translate}}"></dxo-label>
                  </dxi-item>
                  <dxi-item dataField="maxArraySize" editorType="dxNumberBox"
                            [editorOptions]="arraySizeNewOptions" [disabled]="!getDefaultApiConfig(apiKey)?.canDefineMaxArraySize" [colSpan]="2">
                    <dxo-label
                      text="{{'REGISTRY.EXTERNAL_APPLICATION.MAX_ARRAY_SIZE' | translate}}"></dxo-label>
                  </dxi-item>
                </dx-form>
              </div>
            </ng-container>
          </div>
        </div>
      </dxi-tab>

      <dxi-tab [tabTemplate]="'titleWithValidation'"
               title="{{'REGISTRY.EXTERNAL_APPLICATION.TABS.LINKED_PARTITIONS' | translate}}">
        <dxi-item style="gap: 10px; display: flex; flex-direction: column;">
          <div *dxTemplate>
            <div
              style="display: flex; flex-direction: column;gap: 10px; height: 100%">
              <dx-tree-list
                (onSelectionChanged)="onSelectNewExternalApplicationPartitionClick($event)"
                [(selectedRowKeys)]="selectedRowPartitionNewExternalApplicationForm"
                [autoExpandAll]="true"
                [columnAutoWidth]="true"
                [dataSource]="linkedPartitionsFiltered"
                [rootValue]="gmService.user.partition.parentId"
                [showBorders]="true"
                [showRowLines]="false"
                [wordWrapEnabled]="true"
                [selection]="{mode: 'multiple'}"
                id="selectPartitionTree"
                keyExpr="id"
                parentIdExpr="parentId"
              >

                <dxo-toolbar>
                  <dxi-item location="before">
                    <p
                      style="font-size: 22px; margin: 0 0 0 10px;">{{ 'MENU_VOICE.REGISTRY.PARTITIONS' | translate }}</p>
                  </dxi-item>
                  <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
                  </dxi-item>
                </dxo-toolbar>

                <dxo-scrolling
                  mode="standard">
                </dxo-scrolling>

                <dxo-search-panel [visible]="true" placeholder="{{'PLACEHOLDERS.SEARCH' | translate}}">
                </dxo-search-panel>
                <dxi-column caption="{{'REGISTRY.EXTERNAL_APPLICATION.PARTITION' | translate}}"
                            dataField="name"></dxi-column>

              </dx-tree-list>
            </div>
          </div>
        </dxi-item>
      </dxi-tab>
    </dxi-item>

    <div *dxTemplate="let items of 'localeItemTemplate'" class="custom-item">
      <span class="fi fi-{{items.countryFlag}}" style="margin-right: 5px"></span>
      <span class="flagText">{{ printLocaleText(items.locale) }}</span>
    </div>

    <div *dxTemplate="let items of 'localeFieldTemplate'" class="custom-item">
      <dx-text-box [value]="printLocaleText(items?.locale)">
      </dx-text-box>
    </div>

  </dx-form>

</dx-popup>


<dx-popup
  [(visible)]="deletingUser"
  [dragEnabled]="false"
  [focusStateEnabled]="false"
  [height]="200"
  [fullScreen]="appService.isSmallScreen()"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  [showTitle]="true"
  [title]="'REGISTRY.EXTERNAL_APPLICATION.TEXT.DELETE_USER' | translate"
  [width]="660"
>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="deleteUser()" [height]="40" icon="trash" text="{{'BUTTONS.DELETE' | translate}}"
               type="danger"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="deletingUser = false" [height]="40" [stylingMode]="'outlined'"
               icon="close" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
  </dxi-toolbar-item>

  <div style="height: 100%; display: flex; align-items: center;">
    <label
      [innerHTML]="'REGISTRY.USER.TEXT.CONFIRM_DELETE' | translate : { userFirstname: selectedUser?.firstname,  userLastname: selectedUser?.lastname }"
      style="font-size: 18px"></label>
  </div>
</dx-popup>

<dx-popup
  [(visible)]="sendingWelcomeEmail"
  [dragEnabled]="false"
  [focusStateEnabled]="false"
  [height]="200"
  [fullScreen]="appService.isSmallScreen()"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  [showTitle]="true"
  [title]="'REGISTRY.USER.TEXT.SEND_WELCOME_EMAIL' | translate"
  [width]="660"
>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="sendWelcomeEmail(selectedUser!)" [height]="40" icon="email" text="{{'REGISTRY.USER.SEND_WELCOME_EMAIL' | translate}}"
               type="default"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="sendingWelcomeEmail = false" [height]="40" [stylingMode]="'outlined'"
               icon="close" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
  </dxi-toolbar-item>

  <div style="height: 100%; display: flex; align-items: center;">
    <label
      [innerHTML]="'REGISTRY.USER.TEXT.CONFIRM_SEND_WELCOME_EMAIL' | translate : { userFirstname: selectedUser?.firstname,  userLastname: selectedUser?.lastname }"
      style="font-size: 18px"></label>
  </div>
</dx-popup>

<dx-popup
  [(visible)]="resettingPassword"
  [dragEnabled]="false"
  [focusStateEnabled]="false"
  [height]="200"
  [fullScreen]="appService.isSmallScreen()"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  [showTitle]="true"
  [title]="'REGISTRY.USER.RESET_PASSWORD' | translate"
  [width]="660"
>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="resetUserPassword(selectedUser!)" [height]="40" icon="key" text="{{'REGISTRY.USER.RESET_PASSWORD' | translate}}"
               type="default"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="resettingPassword = false" [height]="40" [stylingMode]="'outlined'"
               icon="close" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
  </dxi-toolbar-item>

  <div style="height: 100%; display: flex; align-items: center;">
    <label
      [innerHTML]="'REGISTRY.USER.TEXT.CONFIRM_RESET_PASSWORD' | translate : { userFirstname: selectedUser?.firstname,  userLastname: selectedUser?.lastname }"
      style="font-size: 18px"></label>
  </div>
</dx-popup>

<dx-popup
  [(visible)]="revokingSessions"
  [dragEnabled]="false"
  [focusStateEnabled]="false"
  [height]="200"
  [fullScreen]="appService.isSmallScreen()"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  [showTitle]="true"
  [title]="'REGISTRY.USER.REVOKE_SESSIONS' | translate"
  [width]="660"
>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="revokeUserSessions(selectedUser!)" [height]="40" icon="lock" text="{{'REGISTRY.USER.REVOKE_SESSIONS' | translate}}"
               type="default"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="revokingSessions = false" [height]="40" [stylingMode]="'outlined'"
               icon="close" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
  </dxi-toolbar-item>

  <div style="height: 100%; display: flex; align-items: center;">
    <label
      [innerHTML]="'REGISTRY.USER.TEXT.CONFIRM_REVOKE_SESSIONS' | translate : { userFirstname: selectedUser?.firstname,  userLastname: selectedUser?.lastname }"
      style="font-size: 18px"></label>
  </div>
</dx-popup>

<dx-popup
  [(visible)]="deletingExternalApplication"
  [dragEnabled]="false"
  [focusStateEnabled]="false"
  [height]="200"
  [fullScreen]="appService.isSmallScreen()"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  [showTitle]="true"
  [title]="'REGISTRY.EXTERNAL_APPLICATION.TEXT.DELETE_EXTERNAL_APPLICATION' | translate"
  [width]="660"
>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <!--    <dx-button (onClick)="deleteExternalApplication()" [height]="40" icon="trash"-->
    <!--               text="{{'BUTTONS.DELETE' | translate}}"-->
    <!--               type="danger"></dx-button>-->
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="deleteExternalApplication()" [height]="40" icon="trash"
               text="{{'BUTTONS.DELETE' | translate}}"
               type="danger"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="deletingExternalApplication = false" [height]="40" [stylingMode]="'outlined'"
               icon="close" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
  </dxi-toolbar-item>

  <div style="height: 100%; display: flex; align-items: center;">
    <label
      [innerHTML]="'REGISTRY.EXTERNAL_APPLICATION.TEXT.CONFIRM_DELETE' | translate : { email: selectedExternalApplication?.email }"
      style="font-size: 18px"></label>
  </div>
</dx-popup>

<dx-popup
  [(visible)]="changingSecretKey"
  [dragEnabled]="false"
  [focusStateEnabled]="false"
  [height]="220"
  [fullScreen]="appService.isSmallScreen()"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  [showTitle]="true"
  title="{{'REGISTRY.EXTERNAL_APPLICATION.TEXT.CHANGE_SECRET_KEY' | translate}}"
  [width]="660"
>

  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="changeExternalApplicationSecretKey()" [height]="40" icon="key"
               text="{{'REGISTRY.EXTERNAL_APPLICATION.TEXT.CHANGE_SECRET_KEY' | translate}}"
               type="normal"
               class="change-secret-key-button"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="changingSecretKey = false;" [height]="40" [stylingMode]="'outlined'"
               icon="close" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
  </dxi-toolbar-item>

  <div style="height: 100%; display: flex; align-items: center;">
    <label
      [innerHTML]="'REGISTRY.EXTERNAL_APPLICATION.TEXT.CONFIRM_RESET_SECRET_KEY' | translate : { email: selectedExternalApplication?.email }"
      style="font-size: 18px"></label>
  </div>
</dx-popup>
